<template>
  <SideMenuLayout title="Administration" :items="items">
    <slot/>
  </SideMenuLayout>
</template>

<script>
import SideMenuLayout from "@/components/SideMenuLayout.vue";

// exact : l'entrée n'est active que sur sa propre page (« Groupes » l'est aussi sur le détail d'un groupe)
const TABS = [
  {to: '/administration', label: 'Synthèse', icon: 'grid', exact: true},
  {to: '/administration/groups', label: 'Groupes', icon: 'users'},
  {to: '/administration/containers', label: 'Containers', icon: 'box'},
];

/**
 * Menu latéral de l'espace super admin ; le contenu de la page se place à l'intérieur.
 */
export default {
  name: 'AdministrationHeader',
  components: {SideMenuLayout},
  computed: {
    items() {
      return TABS.map(tab => ({...tab, active: tab.exact ? this.$route.path === tab.to : this.$route.path.startsWith(tab.to)}));
    },
  },
};
</script>
